import type React from "react";
import { ReactComponent as Svg } from "./assets/shield-tick.svg";
import * as styles from "./Icon.module.scss";

type ShieldTickProps = React.SVGProps<SVGSVGElement>;

export const ShieldTick = ({ className, ...props }: ShieldTickProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
